

const ClockIcon = () => {
  return (
<svg width="15" height="15" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8.5" cy="8" r="7.5" stroke="#0C0C0C" strokeWidth="0.62839" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.5 3.42188L8.5 7.99998L10.3704 9.52068" stroke="#0C0C0C" strokeWidth="0.62839" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default ClockIcon